<template>
  <div class="sub-wrap">
    <div class="page-content">
      <div class="content-box">
        <div class="fulfill">
          <img src="https://static.rhkj.com/renhe_fe/other/reportTax/fulfill-check.png" alt="#"/>
        </div>
        <span class="fulfill-title">申报成功</span>
      </div>
      <div class="content-box">
        <p
            v-if="taxQuestionType == 3"
            style="text-align: center">
          <span>您申报的增值税及附加税费申报(一般纳税人适用)申报成功。应补（退）税费额合计为 </span>
          <span style="font-size: 24px; color: #fdc251">{{ pageShowInfo.summary }}</span>
          元 ({{ pageShowInfo.summaryChinese }})。
          <span style="color: #4285f4">展开明细</span>
          <el-icon color="#4285f4">
            <ArrowDown/>
          </el-icon>
        </p>

        <p
            v-if="taxQuestionType == 1"
            style="text-align: center">
          <span>您申报的增值税及附加税费申报(小规模纳税人适用)申报成功。应补（退）税费额合计为 </span>
          <span style="font-size: 24px; color: #fdc251">{{ pageShowInfo.summary }}</span>
          元 ({{ pageShowInfo.summaryChinese }})。
          <span style="color: #4285f4">展开明细</span>
          <el-icon color="#4285f4">
            <ArrowDown/>
          </el-icon>
        </p>

        <p
            v-if="taxQuestionType == 2 || taxQuestionType == 6"
            style="text-align: center">
          <span>您申报的居民企业（查账征收）企业所得税月（季）度申报申报成功。应补（退）税费额合计为 </span>
          <span style="font-size: 24px; color: #fdc251">{{ pageShowInfo.back }}</span>
          元 ({{ pageShowInfo.backChinese }})。
          <span style="color: #4285f4">展开明细</span>
          <el-icon color="#4285f4">
            <ArrowDown/>
          </el-icon>
        </p>


        <p
            v-if="taxQuestionType == 4"
            style="text-align: center">
          <span>您申报的财产和行为税税源采集及合并申报申报成功。应补（退）税费额合计为 </span>
          <span style="font-size: 24px; color: #fdc251">{{ pageShowInfo.back }}</span>
          元 ({{ pageShowInfo.backChinese }})。
          <span style="color: #4285f4">展开明细</span>
          <el-icon color="#4285f4">
            <ArrowDown/>
          </el-icon>
        </p>

        <p
            v-if="taxQuestionType == 5"
            style="text-align: center">
          <span>您申报的财务报表报送及更正申报成功。应补（退）税费额合计为 </span>
          <span style="font-size: 24px; color: #fdc251">{{ pageShowInfo.back }}</span>
          元 ({{ pageShowInfo.backChinese }})。
          <span style="color: #4285f4">展开明细</span>
          <el-icon color="#4285f4">
            <ArrowDown/>
          </el-icon>
        </p>

        <p
            v-if="taxQuestionType == 201"
            style="text-align: center">
          <span>您申报的居民企业（查账征收）企业所得税年度申报申报成功。应补（退）税费额合计为 </span>
          <span style="font-size: 24px; color: #fdc251">{{ pageShowInfo.back }}</span>
          元 ({{ pageShowInfo.backChinese }})。
          <span style="color: #4285f4">展开明细</span>
          <el-icon color="#4285f4">
            <ArrowDown/>
          </el-icon>
        </p>
      </div>

      <!--底部按钮区-->
      <div
          v-if="taxQuestionType == 2 || taxQuestionType == 6"
          style="width: 100%; margin-top: 20px; text-align: center">
        <el-button plain @click="emit('payTax')">立即缴款</el-button>
        <el-button type="primary" @click="emit('backHome')">返回首页</el-button>
      </div>

      <div
          v-if="taxQuestionType == 1 || taxQuestionType == 3 || taxQuestionType == 4 || taxQuestionType == 201"
          style="width: 100%; margin-top: 20px; text-align: center">
        <el-button @click="emit('payTax')">立即缴款</el-button>
        <el-button type="primary">评价</el-button>
      </div>

      <div
          v-if="taxQuestionType == 5"
          style="width: 100%; margin-top: 20px; text-align: center">
        <el-button plain>评价</el-button>
        <el-button type="primary" @click="emit('backHome')">返回首页</el-button>
      </div>


      <div class="download-box">
        <h3 style="font-size: 18px; line-height: 40px; font-weight: 700">您可能需要</h3>
        <p style="line-height: 40px">
          查看、下载或打印本次申报报表信息
          <el-button type="primary" text>查看</el-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {toCapitalChinese} from "@/utils/number";
import Big from "big.js";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const emit = defineEmits(['backHome', 'payTax'])

const taxQuestionType = computed(() => {
  switch (props.currentQa.sonQueType) {
    case '21':
      return 1
    case '26': // 企税--一般
    case '22': // 企税--小规模
      return 2
    case '23':
      return 3
    case '24': // 印花税--小规模
    case '25': // 印花税--一般
      return 4
    case '27':
    case '28':
    case '29': // 汇算清缴-财务报表报送
      return 5
    case '201': //汇算清缴-企业所得税年度申报
      return 201
    case '2201': // 企税v2025
    case '2601':
      return 6
    default:
      throw new Error('不支持的类型')
  }
})

// 题目json信息转js对象
const qaData = computed(() => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll
})

// 页面显示合计的金额
const pageShowInfo = computed(() => {
  let summary = '0.00'
  if (taxQuestionType.value == 3) {
    summary = parseFloatNum(
        new Big(qaData.value.tax31.data.v34x1.value)
            .plus(qaData.value.tax31.data.v39x1.value)
            .plus(qaData.value.tax31.data.v40x1.value)
            .plus(qaData.value.tax31.data.v41x1.value)
    )
  } else if (taxQuestionType.value == 1) {
    summary = parseFloatNum(
        new Big(qaData.value.tax11.data.v22x1.value)
            .plus(qaData.value.tax11.data.v23x1.value)
            .plus(qaData.value.tax11.data.v24x1.value)
            .plus(qaData.value.tax11.data.v25x1.value)
    )
  }

  let back = '0.00'
  if (taxQuestionType.value == 2) {
    back = parseFloatNum(qaData.value.tax21.data.v28x1.value)
  } else if (taxQuestionType.value == 6) {
    back = parseFloatNum(qaData.value.tax21.data.v50x2.value)
  }

  if (taxQuestionType.value == 4) { // 印花税
    const data = qaData.value.data;
    const num1 = parseFloatNum(data.reduce((a, b) => new Big(a).plus(b.amountPayable), 0));
    const num2 = parseFloatNum(new Big(num1).div(2).round(2).toNumber());
    back = parseFloatNum(new Big(num1).minus(num2)); // num3
  } else if (taxQuestionType.value == 201) {
    back = parseFloatNum(qaData.value.tax53.data.v45x1.value)
  }

  return {
    summary: summary, // 第1、3题取这个
    summaryChinese: toCapitalChinese(summary),
    back, // 第2题、201题
    backChinese: toCapitalChinese(back),
  }
})

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {
    console.log(e);
  }
}
</script>

<style scoped lang="scss">
.sub-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  overflow-y: auto;

  .page-content {
    width: 800px;
    height: 680px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .content-box {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .fulfill {
        width: 60px;
        height: 60px;

        > img {
          width: 100%;
          object-fit: cover;
        }
      }

      .fulfill-title {
        font-size: 30px;
        font-weight: 700;
        margin-top: 10px;
      }
    }

    .download-box {
      width: 900px;
      padding: 20px;
      margin-top: 10px;
      background-color: #f8fdff;
    }
  }
}
</style>
